/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AudioDeviceIconType {
    VOG = 1,
    Trainer = 2,
    Microphone = 3,
    iconXLR = 4,
    VTP = 5,
    CAM = 6,
    WirelessMic = 7,
    Telephone = 8,
}
